/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Kind_Locked_HintInputs */

const cs_templates_kind_locked_hint = /** @type {(inputs: Templates_Kind_Locked_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Druh šablony je po vytvoření zamčený. Pro jiný druh vytvořte novou šablonu nebo kopii.`)
};

const en_templates_kind_locked_hint = /** @type {(inputs: Templates_Kind_Locked_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Template kind is locked after create. For another kind, create a new template or fork.`)
};

/**
* | output |
* | --- |
* | "Template kind is locked after create. For another kind, create a new template or fork." |
*
* @param {Templates_Kind_Locked_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_kind_locked_hint = /** @type {((inputs?: Templates_Kind_Locked_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Kind_Locked_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_kind_locked_hint(inputs)
	return cs_templates_kind_locked_hint(inputs)
});